module.exports = __webpack_public_path__ + "img/login_bar_bg.0f3b9d8b.jpg";